import React from 'react'
import TemplateForm from './TemplateForm'

/** The Create Template page: the template form with nothing loaded. */
const CreateTemplate = () => <TemplateForm />

export default CreateTemplate
